import { z } from "zod";

/** OSS `GET .../s3/bucket/:bucket/object?download=true&key=...` — presigned download metadata */
export const downloadObjectResponseSchema = z.object({
  downloadUrl: z.string().url(),
  expiresAt: z.string(),
  expiresInSeconds: z.number(),
});

export type DownloadObjectResponse = z.infer<typeof downloadObjectResponseSchema>;
